import React from 'react';
import PropTypes from 'prop-types';
import Icon from '@hobs/components/Icon';
import Styles from './ServiceRequestFooter.module.scss';

const ServiceRequestFooter = ({ message, children }) => {
  return (
    <div className={Styles['service-request-footer']}>
      {message ? (
        <div className={Styles['service-request-message']}>
          <Icon
            className={Styles['service-request-message--notification']}
            icon="InfoSmall"
          />
          <div>{message}</div>
        </div>
      ) : (
        <div />
      )}
      <div className={Styles['service-request-controls']}>{children}</div>
    </div>
  );
};

ServiceRequestFooter.propTypes = {
  children: PropTypes.any,
  message: PropTypes.string
};

export default ServiceRequestFooter;
